var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitbucketLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.721583 5.92509e-05C0.617617 -0.00128166 0.514617 0.0201519 0.419816 0.0628542C0.325014 0.105557 0.240709 0.168493 0.17282 0.247244C0.104931 0.325996 0.0551027 0.418654 0.0268344 0.518712C-0.00143393 0.618771 -0.00745721 0.723804 0.00918742 0.826438L3.03331 19.1849C3.07099 19.4095 3.18662 19.6137 3.35989 19.7616C3.53317 19.9095 3.75301 19.9916 3.98079 19.9934H18.4887C18.6595 19.9956 18.8253 19.9364 18.9561 19.8266C19.0869 19.7168 19.1738 19.5636 19.2011 19.395L22.2324 0.833562C22.249 0.730928 22.243 0.625895 22.2147 0.525836C22.1865 0.425778 22.1366 0.33312 22.0687 0.254368C22.0008 0.175617 21.9165 0.112681 21.8217 0.0699783C21.7269 0.027276 21.6239 0.00584246 21.52 0.00718337L0.721583 5.92509e-05ZM13.4557 13.2684H8.82508L7.57127 6.72151H14.5777L13.4557 13.2684Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2635 6.72151H14.5777L13.4556 13.2684H8.82506L3.35742 19.7619C3.53072 19.9118 3.75167 19.9951 3.98077 19.997H18.4923C18.663 19.9992 18.8289 19.94 18.9596 19.8302C19.0904 19.7203 19.1774 19.5672 19.2047 19.3986L21.2635 6.72151Z",
    fill: "url(#paint0_linear_101_61)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_61",
    x1: 22.8094,
    y1: 8.55237,
    x2: 11.7601,
    y2: 17.1795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucketLogo);
export default __webpack_public_path__ + "static/media/bitbucket-logo.3a8a83306a828367e6e43f2a44720f77.svg";
export { ForwardRef as ReactComponent };